import common from '@page/common/js/common';
import Pagination from '@global/components/global/Pagination';
import wishBtn from '@global/components/member/wishBtn';
import Slick from '@global/vendors/vue-slick.vue';
import GridMode from '@page/shop/components/GridMode.vue';
import SortApp from '@page/shop/components/SortApp.vue';
import Recommend from '@page/shop/components/Recommend.vue';
import Vue from 'vue';
import $ from 'jquery';
import axios from 'axios';
import store from '@global/components/store/index';
import fireShopListViewEvent from '@global/gtm/shopList/shopListView';
import fireShopListClickGTMEvent from '@global/gtm/shopList/clickList';
import PictureFilter from '@global/components/productList_vue/PictureFilter.vue';

require('@global/vendors/jquery.sticky-kit');

const shop = new Vue({
  el: '#app-shop',
  name: 'ShopList',
  store,
  components: {
    wishBtn,
    GridMode,
    SortApp,
    Recommend,
    PictureFilter,
  },
  data: {
    largeMode: false,
    sortConditionDatas: null,
    sortConditionIsLoad: false,
    bannerSliderConfig: {
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: false,
      speed: 800,
      autoplay: true,
      autoplaySpeed: 6000,
    },
  },
  created() {
    this.getSortCondition();
  },
  mounted() {
    if ($('.banner-slide').length) {
      $('.banner-slide').slick(this.bannerSliderConfig);
    }
  },
  methods: {
    swichGridMode(lMode) {
      this.largeMode = lMode;
    },
    getSortCondition() {
      axios.get(API_URL.SORT_POPUP).then((res) => {
        if (res.data.Code === 200) {
          this.sortConditionDatas = res.data.Response;
          this.sortConditionIsLoad = true;
        }
      });
    },
    fireGTM(customMarketID) {
      fireShopListClickGTMEvent({ customMarketID });
    },
  },
});

const pagination = new Vue({
  el: '#pagination',
  components: { Pagination },
  template: '<div><Pagination></Pagination></div>',
});

if ($('.item-box').length > 3) {
  $('#category-sidebar').stick_in_parent({ offset_top: 200 });
}

if (!window.location.pathname.includes('search')) {
  fireShopListViewEvent();
}
